// import "./../styles/button.css";

// Button component
/**
 * Button component
 * @param props - The properties to customize the button
 * @returns A styled button element
 *
 * Componente simples de botão com algumas propriedades personalizáveis.
 */
// import "./../styles/button.css";

// Button component
/**
 * Button component
 * @param props - The properties to customize the button
 * @returns A styled button element
 *
 * Componente simples de botão com algumas propriedades personalizáveis.
 */
const Button = (props: any) => {
  return (
    <button
      className={`
      button
      w-auto
      font-bold
      py-2
      rounded-lg
      transition-opacity
      ${props.className ?? ""}
      ${props.disabled || props.loading ? "opacity-50 cursor-not-allowed" : ""}
      `}
      type={props.type}
      data-testid={props.testid}
      style={{
        background: props.color,
        width: props.styles,
        color: props.fontColor,
        borderColor: props.borderColor,
        boxShadow: props.boxShadow,
        transform: props.transform,
      }}
      onClick={() => {
        if (props.type !== "submit" && props.click) {
          props.click(props.function);
        }
      }}
      disabled={props.disabled || props.loading}
    >
      {props.loading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-gray-300 border-t-[var(--color-primaria)]" />
        </div>
      ) : (
        props.name
      )}
    </button>
  );
};

export default Button;
